// @flow

import type { Node } from 'react';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@riseart/common';
import { SwipeRightIcon, SwipeLeftIcon } from '@riseart/icons';
import { Overlay } from '@riseart/layout';
import { cookies as CONFIG_COOKIES } from 'Config';
import { Cookies } from 'shared_services/riseart/utils/Cookies/Cookies';

import {
  quizSwipeOverlayCls,
  quizSwipeOverlayContainerCls,
  quizSwipeOverlayTextCls,
} from 'shared_components/quiz/overlay/Overlay.less';

/**
 * QuizOverlay
 *
 * @returns Node
 */
export function QuizOverlay(): Node {
  const [wasHintShown, setWasHintShown] = useState(
    Cookies.get(CONFIG_COOKIES.quizHintSession.name),
  );

  const handleClick = useCallback((): void => {
    setWasHintShown(true);
    Cookies.set(CONFIG_COOKIES.quizHintSession.name, true, CONFIG_COOKIES.quizHintSession);
  }, []);

  return (
    <Overlay isVisible={!wasHintShown} type="semitransparent" className={quizSwipeOverlayCls}>
      <div className={quizSwipeOverlayContainerCls}>
        <div className={quizSwipeOverlayTextCls}>
          <FormattedMessage id="components.quiz.swipe_right" />
          <SwipeRightIcon />
        </div>
        <div className={quizSwipeOverlayTextCls}>
          <FormattedMessage id="components.quiz.swipe_left" />
          <SwipeLeftIcon />
        </div>
        <Button type="ghost" size="xlarge" width="container" onClick={handleClick}>
          <FormattedMessage id="components.quiz.swipe_btn_text" />
        </Button>
      </div>
    </Overlay>
  );
}
